<template>
  <div>
    <QCard class="my-card">
      <QCardSection class="bg-primary text-white">
        <div class="text-h6">Ecosystem</div>
      </QCardSection>
      <QSeparator dark />
      <QCardSection>
        Several documentation links to modules and plugins used inside this
        project
      </QCardSection>
      <QSeparator dark />
      <QCardActions class="bg-primary text-white">
        <QBtnGroup>
          <QBtn type="a" target="_blank" href="https://router.vuejs.org" color="secondary">Router</QBtn>
          <QBtn type="a" target="_blank" href="https://vuex.vuejs.org" color="secondary">Vuex</QBtn>
          <QBtn
            type="a"
            target="_blank"
            href="https://github.com/vuejs/vue-devtools#vue-devtools"
            color="secondary"
          >DevTools</QBtn>
          <QBtn
            type="a"
            target="_blank"
            href="https://vue-loader.vuejs.org"
            color="secondary"
          >Loaders</QBtn>
          <QBtn
            type="a"
            target="_blank"
            href="https://github.com/vuejs/awesome-vue"
            color="secondary"
          >Awesome-vue</QBtn>
        </QBtnGroup>
      </QCardActions>
    </QCard>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import {
  QPage,
  QCard,
  QCardSection,
  QCardActions,
  QBtnGroup,
  QBtn,
  QSeparator,
  QIcon
} from "quasar";

@Component({
  components: {
    QPage,
    QCard,
    QCardSection,
    QCardActions,
    QBtn,
    QBtnGroup,
    QSeparator,
    QIcon
  }
})
export default class Ecosystem extends Vue {}
</script>

<style lang="sass" scoped>
.my-card
  display: inline-block
  margin: 0.5em
</style>
